var path = 'app/scripts/modules/openstack/src/common/refresh.tooltip.html';
var html = "<p ng-if=\"$ctrl.refreshing\">{{$ctrl.label}} list is <strong>refreshing</strong>.</p>\n<p ng-if=\"!$ctrl.refreshing\">Click <span class=\"fa fa-refresh\"></span> to refresh {{$ctrl.label}} list.</p>\n<p>Last Updated:<br>{{$ctrl.lastRefresh | timestamp }}<br>({{$ctrl.lastRefresh | relativeTime }})</p>\n<p class='small'><strong>Note:</strong> Due to caching, data may be delayed up to 2 minutes</p>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/openstack/src/common/refresh.tooltip.html
// module id = 1393
// module chunks = 0